import { render, staticRenderFns } from "./CrewsTable.vue?vue&type=template&id=50c5ccf8&scoped=true"
import script from "./CrewsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CrewsTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CrewsTable.vue?vue&type=style&index=0&id=50c5ccf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c5ccf8",
  null
  
)

export default component.exports